@if (hasContent) {
  <div class="sidebar-ad" role="complementary" [attr.aria-label]="'sidebar.advertising' | t">
    <div class="sidebar-ad-header">{{ 'sidebar.advertising' | t }}</div>

    @if (showAdsense) {
      <ins #adsenseSlot class="adsbygoogle sidebar-adsense"
        [attr.data-ad-client]="adsenseClient"
        [attr.data-ad-slot]="adsenseSlotId"
        data-ad-format="auto"
        data-full-width-responsive="true"></ins>
    }

    @for (banner of banners; track banner._id) {
      <a class="sidebar-banner" [href]="banner.linkUrl" target="_blank" rel="sponsored noopener">
        <img [src]="pictureOf(banner)" [alt]="banner.name" loading="lazy" (error)="onPictureError(banner, $event)">
      </a>
    }
  </div>
}
